import { Injectable } from '@angular/core';
import { IOrganization, ISegment, ITag } from '../../types/contactModule';
import { IEntitySegmentQuery } from '../../components/organization/segments/segment-utilities';
import { forkJoin, firstValueFrom } from 'rxjs';
import { ContactsService } from '../contacts/contacts.service';

interface ItemList {
  id: number;
  name: string;
  checked?: boolean;
  [key: string]: any;
}

export interface RecipientForm {
  organizations: IOrganization[];
  tags: ITag[];
  segments: IEntitySegmentQuery[];
}
@Injectable({
  providedIn: 'root',
})
export class RecipientsService {
  constructor(private contactsService: ContactsService) {}

  recipients: RecipientForm = {
    organizations: [],
    tags: [],
    segments: [],
  };
  totalRecipientsCount: number = 0;

  // not using this
  getTotalRecipientsCount(): void {
    const orgObservables = this.recipients.organizations.map((org) =>
      this.contactsService.fetchOrganizationContactsCount(org.uuid || '')
    );

    const tagObservables = this.recipients.tags.map((tag) =>
      this.contactsService.fetchTagsContactsCount(tag.uuid || '')
    );

    const segmentObservables = this.recipients.segments.map((segment) =>
      this.contactsService.fetchSegmentContactsCount(segment.uuid || '')
    );

    const allObservables = [
      ...orgObservables,
      ...tagObservables,
      ...segmentObservables,
    ];

    forkJoin(allObservables).subscribe({
      next: (counts) => {
        this.totalRecipientsCount = (counts as any[]).reduce(
          (sum: number, count: any) => {
            // Handle tag count which comes as an object with count property
            const countValue =
              typeof count === 'object' && count?.count ? count.count : count;
            return sum + countValue;
          },
          0
        );
      },
      error: (error) => {
        this.totalRecipientsCount = 0;
      },
    });
  }

  reset() {
    this.recipients = {
      organizations: [],
      tags: [],
      segments: [],
    };
  }
}
